import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { ResourceListSelectors, SeasonState } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors((state: RootState): SeasonState => state.season);

export default selectors;
